import { PageHeader } from '@/shared/components/ui/PageHeader';
import { Wallet } from 'lucide-react';
import { ContentContainer } from '@/shared/layouts/ContentContainer';
import { HRPayrollWidget } from '@/features/dashboard/widgets/hr/HRPayrollWidget';

export function PayrollPage() {
  return (
    <ContentContainer>
      <div className="mb-4">
        <PageHeader icon={Wallet} eyebrow="People" title="Payroll Management" description={<>Compensation, payroll runs and salary slips</>} />
      </div>
      <HRPayrollWidget />
    </ContentContainer>
  );
}
